// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.k20zdVOcklkfJs {
  display: flex;
  position: relative;
  align-items: center;
  min-height: 40px;
  padding: 12px 0;
  column-gap: 12px;
  border-bottom: 1px solid var(--ds-border, #091e4224);
}
@media only screen and (max-width: 750px) {
  .k20zdVOcklkfJs {
    flex-flow: row wrap;
  }
}
.Wf5cE1CWEGdmu6 {
  flex-grow: 1;
}
.Wf5cE1CWEGdmu6 p {
  margin: 0;
}
.Wf5cE1CWEGdmu6 strong {
  margin-right: 4px;
  font-size: 16px;
  font-weight: 700;
  word-break: break-word;
}
.zE7oX65Gg2TDWS {
  max-width: 450px;
  overflow-wrap: break-word;
  color: var(--ds-text-subtle, #44546f);
}
.zUrbZXo229yMe8 {
  margin-right: 4px;
}
.Q_b5Uj3GwydscM {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  column-gap: 12px;
}
@media only screen and (max-width: 750px) {
  .Q_b5Uj3GwydscM {
    flex: 0;
  }
}
.Q_b5Uj3GwydscM button {
  margin: 0;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"workspaceMemberListItem": `k20zdVOcklkfJs`,
	"memberListItemNames": `Wf5cE1CWEGdmu6`,
	"memberListItemUsernameAndLastActive": `zE7oX65Gg2TDWS`,
	"bulletSeparator": `zUrbZXo229yMe8`,
	"memberListItemOptions": `Q_b5Uj3GwydscM`
};
export default ___CSS_LOADER_EXPORT___;
